import { h } from 'preact';
import PropTypes from 'prop-types';

import { IconPlay, IconPause } from '../../1-foundation/icons/icons';

const PlayPause = ({ onClick, isPlaying }) =>
  !isPlaying ? (
    <IconPlay classNames="icon--audio" onClick={onClick} />
  ) : (
    <IconPause classNames="icon--audio" onClick={onClick} />
  );

PlayPause.propTypes = {
  isPlaying: PropTypes.string,
  onClick: PropTypes.func.isRequired,
};

export default PlayPause;
